import { IOption } from '@cmps/ng-select';

import { Column, Row, Sort } from '../../experimental.grid';

import {
    ColumnContext,
    RowContext,
} from './direct-report-contribution-grid.model';
import { RankColumnContext } from './direct-report-rank-grid.model';
import { FilterPillar } from './team-grid.model';

export interface DirectReportContributionGrid {
    scorecardId?: number;
    columns?: Array<Column<ColumnContext>>;
    rowsTop?: Array<Row<RowContext>>;
    rows?: Array<Row<RowContext>>;
    sortDefs?: Sort[];
    filterDef?: IOptionScorecard[];
    filterPillar?: FilterPillar[];
    superGroupName?: string;

    /**
     * @deprecated
     * top row column id order.
     * TODO remove. this was originally for ordering the pillars in the order that they picked on the ui, but that seems to not be required anymore
     */
    defaultColumnIdOrder?: string[];
}

export interface DirectReportScorecardGrid {
    scorecardId?: number;
    columns?: Array<Column<ColumnContext>>;
    rows?: Array<Row<RowContext>>;
    sortDefs?: Sort[];
    superGroupName?: string;
    filterDef?: IOptionScorecard[];
    filterPillar?: FilterPillar[];

    /**
     * @deprecated
     * top row column id order.
     * TODO remove. this was originally for ordering the pillars in the order that they picked on the ui, but that seems to not be required anymore
     */
    defaultColumnIdOrder?: string[];
}

export interface IOptionScorecard extends IOption {
    isSelected?: boolean;
}

export interface DirectReportRankGrid {
    scorecardId?: number;
    columns?: Array<Column<RankColumnContext>>;
    rows?: Array<Row<{}>>;
    sortDefs: Sort[];
    filterDef?: IOptionScorecard[];
}

export interface TeamGridState {
    headerList: number[];
    directReportContributionGrid: DirectReportContributionGrid;
    directReportContributionGridExpandedAll?: boolean;
    directReportRankGrid: DirectReportRankGrid;
    directReportScorecardGrid: DirectReportScorecardGrid;
    directReportScorecardGridExpandedAll?: boolean;
    directReportPrevRankGrid: DirectReportRankGrid;
    directReportPrevContributionGrid: DirectReportContributionGrid;
    directReportPrevScorecardGrid: DirectReportScorecardGrid;
}

export const defaultTeamGridState = (): TeamGridState => ({
    headerList: [],
    directReportContributionGrid: {
        sortDefs: [],
    },
    directReportPrevContributionGrid: {
        sortDefs: [],
    },
    directReportRankGrid: {
        sortDefs: [],
    },
    directReportPrevRankGrid: {
        sortDefs: [],
    },
    directReportScorecardGrid: {
        sortDefs: [],
    },
    directReportPrevScorecardGrid: {
        sortDefs: [],
    },
});
